import type { Vuelos } from "@/lib/api/vuelos/types";

// Clave usada para pasar la selección de vuelos desde el planificador
// (/conexion) hacia la página de resultado (/conexion/resultado) sin
// depender de query params largos. Vive solo en sessionStorage.
export const CONNECTION_STORAGE_KEY = "tocumen:conexion:seleccion";

export type ConnectionSelection = {
  arrival: Vuelos;
  departure: Vuelos;
};

export function saveConnectionSelection(seleccion: ConnectionSelection) {
  try {
    sessionStorage.setItem(
      CONNECTION_STORAGE_KEY,
      JSON.stringify(seleccion),
    );
  } catch {
    // sessionStorage puede no estar disponible (SSR / modo privado).
  }
}

export function readConnectionSelection(): ConnectionSelection | null {
  try {
    const raw = sessionStorage.getItem(CONNECTION_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as ConnectionSelection;
  } catch {
    return null;
  }
}
